import React, { useState, useEffect } from 'react';
import '../../styles/parent/LeftColumn.css';
import { supabase } from '../../utils/supabase';
import { fetchParentProfile } from '../../utils/parentProfileService';
import { fetchTeacherConnection } from '../../utils/teacherConnectionService';

const LeftColumn = ({ onStudentNameLoad }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [parentName, setParentName] = useState('Parent');
  const [studentName, setStudentName] = useState('');
  const [grade, setGrade] = useState('');
  const [school, setSchool] = useState('');
  const [parentProfile, setParentProfile] = useState(null);
  const [teacherInfo, setTeacherInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleProfileClick = () => {
    setIsEditing(!isEditing);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get current logged-in user from Supabase
        const { data: { user } } = await supabase.auth.getUser();
        
        if (user) {
          console.log('👤 Fetching parent profile for user:', user.id);
          
          // Fetch parent profile data using the actual logged-in user ID
          const parentData = await fetchParentProfile(user.id);
          console.log('🔍 Raw parent data response:', parentData);
          
          if (parentData) {
            console.log('🔍 Debug: Parent data received:', parentData);
            setParentProfile(parentData);
            // Prioritize username over other fields to get the actual name
            setParentName(parentData.username || parentData.fullName || parentData.relationshipToStudent || 'Parent');
            
            const studentNameFromProfile = (parentData.yourStudentName || '').trim();
            console.log('👨‍🎓 Student name from profile:', studentNameFromProfile);
            setStudentName(studentNameFromProfile);
            setGrade(parentData.studentsCurrentGrade || '');
            setSchool(parentData.studentsSchool || '');
            
            // Pass student name to parent component
            if (onStudentNameLoad) {
              console.log('📤 Calling onStudentNameLoad with:', studentNameFromProfile);
              onStudentNameLoad(studentNameFromProfile);
            }
            
            // Fetch teacher connection information
            if (studentNameFromProfile) {
              const teacherData = await fetchTeacherConnection(studentNameFromProfile);
              if (teacherData) {
                console.log('🔍 Debug: Teacher data received:', teacherData);
                setTeacherInfo(teacherData);
              }
            }
          } else {
            console.warn('⚠️ No parent data found for user:', user.id);
            if (onStudentNameLoad) onStudentNameLoad('');
          }
        } else {
          console.warn('⚠️ No user logged in');
          if (onStudentNameLoad) onStudentNameLoad('');
        }
      } catch (error) {
        console.error('Error fetching parent data:', error);
        if (onStudentNameLoad) onStudentNameLoad('');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [onStudentNameLoad]);


  return (
    <div className="parent-left-column">
      <div className="profile-card" onClick={handleProfileClick}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '1rem', color: '#666' }}>
            Loading parent information...
          </div>
        ) : (
          <>
            <h1 className="parent-name" 
                contentEditable={isEditing}
                suppressContentEditableWarning={true}
                onBlur={(e) => setParentName(e.target.textContent)}
                style={{ cursor: isEditing ? 'text' : 'pointer', marginTop: '1rem' }}>
              {(parentProfile?.username || parentProfile?.fullName || parentProfile?.relationshipToStudent || parentName).toUpperCase()}
            </h1>
          </>
        )}
        
        <h2 className="profile-name" 
            contentEditable={isEditing}
            suppressContentEditableWarning={true}
            onBlur={(e) => setStudentName(e.target.textContent)}
            style={{ cursor: isEditing ? 'text' : 'pointer' }}>
          <div>{parentProfile?.relationshipToStudent || 'Parent'} of</div>
          <div style={{ fontWeight: 'bold', marginTop: '0.3rem' }}>
            {parentProfile?.yourStudentName || studentName || 'No student linked'}
          </div>
        </h2>
        
        {/* Divider Line */}
        <div className="profile-divider"></div>

        {/* Teacher Details Section */}
        <div className="teacher-details-section">
          <h3 className="teacher-section-title">Teacher Information</h3>
          
          {loading ? (
            <div style={{ textAlign: 'center', padding: '1rem', color: '#666' }}>
              Loading teacher information...
            </div>
          ) : teacherInfo ? (
            <>
              <div className="teacher-detail-item">
                <h4 className="detail-label">Name of the Teacher:</h4>
                <p className="detail-value">{teacherInfo.FullName || 'Teacher Name'}</p>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '1rem', color: '#666' }}>
              No teacher information available
            </div>
          )}
          
          <div style={{ marginTop: '9rem', display: 'flex', justifyContent: 'center' }}>
            <button className="simple-message-btn app-btn" onClick={() => console.log('Opening message interface...')}>
              <span>Message Teacher</span>
            </button>
          </div>
        </div>

      </div>
      {/* Placeholder content below profile card */}
    </div>
  );
};

export default LeftColumn;